module.exports = __webpack_public_path__ + "img/motorrrad_teaser.d9a3d26f.jpg";